import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import getContentProtectedDisClosure from '@kfc-global/react-shared/redux/Actions/ProtectedDisclosureAction';
import { getProtectedDisclosureData, isEmptyObject } from 'common/utilities/utils';
import { getCmsClient } from 'common/utilities/cmsClient';
import get from 'lodash/get';
import ProtectedDisclosureContainer from 'organisms/ProtectedDisclosure/Container/ProtectedDisclosureContainer';

const ProtectedDisclosure = props => {
  const dispatch_ = useDispatch();
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  useEffect(() => {
    dispatch_(
      getContentProtectedDisClosure({
        object: getCmsClient(),
        contentFull: {
          content_type: 'staticLandingPage',
          'fields.page': 'Protected Disclosure',
          include: '5',
        },
      }),
    );
  }, [dispatch_]);

  let segmentedProtectedDisclosure = null;
  const allReducerData = useSelector(data => {
    return {
      protectedDisclosureContent: get(data, 'protectedDisclosureReducer.response', null),
    };
  });
  if (isEmptyObject(allReducerData?.protectedDisclosureContent)) {
    segmentedProtectedDisclosure = getProtectedDisclosureData(allReducerData?.protectedDisclosureContent);
  }
  return (
    <React.Fragment>
      {isEmptyObject(segmentedProtectedDisclosure) && (
        <ProtectedDisclosureContainer content={segmentedProtectedDisclosure} userParams={userParams} />
      )}
    </React.Fragment>
  );
};

export default ProtectedDisclosure;
